import React from "react";
import styles from "./learningTool.module.css";
import LearningToolVocabulary from "../learningToolVocabulary/LearningToolVocabulary";
import LearningToolCloze from "../learningToolCloze/LearningToolCloze";
import LearningToolMultipleChoice from "../learningToolMultipleChoice/LearningToolMultipleChoice";
import LearningToolImgToWord from "../learningToolImgToWord/LearningToolImgToWord";

const LearningTool = ({
  tool,
  currUsername,
  lzCreatorUsername,
  isCreatorOrAdmin,
  removeToolFromList,
  maxUnitsPerTool,
}) => {
  /* Display a single learning tool. A learning tool can be of one of four types: vocabulary, cloze, multiple choice, or image to word. This component uses specific components of these types. */

  const toolCreatorUsername = tool.username;

  const mayEditTool =
    currUsername === lzCreatorUsername ||
    currUsername === toolCreatorUsername ||
    isCreatorOrAdmin;

  return (
    <div className={styles.tool}>
      {tool.tool_type_id === "vocabulary" && (
        <LearningToolVocabulary
          tool={tool}
          mayEditTool={mayEditTool}
          removeToolFromList={removeToolFromList}
          maxUnitsPerTool={maxUnitsPerTool}
        />
      )}

      {tool.tool_type_id === "cloze" && (
        <LearningToolCloze
          tool={tool}
          mayEditTool={mayEditTool}
          removeToolFromList={removeToolFromList}
          maxUnitsPerTool={maxUnitsPerTool}
        />
      )}

      {tool.tool_type_id === "multipleChoice" && (
        <LearningToolMultipleChoice
          tool={tool}
          mayEditTool={mayEditTool}
          removeToolFromList={removeToolFromList}
          maxUnitsPerTool={maxUnitsPerTool}
        />
      )}

      {tool.tool_type_id === "imgToWord" && (
        <LearningToolImgToWord
          tool={tool}
          mayEditTool={mayEditTool}
          removeToolFromList={removeToolFromList}
          maxUnitsPerTool={maxUnitsPerTool}
        />
      )}
    </div>
  );
};

export default LearningTool;
